// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cQQ7","colBig":"styles_colBig__2G5FI","colSmall":"styles_colSmall__1MwBe"};